"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpendingForPeriods = exports.getIncomeForPeriods = void 0;
const re_reselect_1 = require("re-reselect");
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const selectors_1 = require("data/transactions/selectors");
const objectToKeyUtils_1 = require("utils/objectToKeyUtils");
const memoizeWithKey_1 = require("utils/memoizeWithKey");
const selectorsHelpers_1 = require("utils/selectorsHelpers");
const utils_1 = require("data/otReports/utils");
const log = (0, core_1.getLogger)('data/otReports/selectors');
/**
 * Get income data grouped by frequency
 */
exports.getIncomeForPeriods = (0, re_reselect_1.createCachedSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state) || categories_1.categoriesSelectors.getLoadPending(state) || (0, selectors_1.getLoadPending)(state), accounts_1.accountsSelectors.getReportableAccountsById, (_state, props) => props.accountIds, selectors_1.getTransactionsByAccountId, categories_1.categoriesSelectors.getCategoriesById, (_state, props) => props.dateInterval, (_, props) => props.frequency, (_, props) => props.filterCriteria, (_, props) => props.filterBySource, (isLoadPending, allAccountsByIds, accountIds, transactionsByAccountId, categoriesById, dateInterval, frequency, filterCriteria, filterBySource) => {
    // accounts, categories, and transactions must all be loaded before we attempt to calculate spending
    if (isLoadPending) {
        return null;
    }
    // turn into trace statement after fixing issues with input properties changing all the time
    log.log('calculating income for', allAccountsByIds, accountIds, dateInterval);
    // will default to a monthly frequency
    let frequencyData = utils_1.monthlyFrequencyData;
    switch (frequency) {
        case 'monthly':
            frequencyData = utils_1.monthlyFrequencyData;
            break;
        default:
            break;
    }
    // const parsedFilterCriteria = JSON.parse(filterCriteria); // quick fix for failing unit tests, seems unnecessary but was being passed to calculateValuesForPeriods
    const accountIdsToUse = accountIds || allAccountsByIds.keySeq();
    return (0, utils_1.calculateValuesForPeriods)(accountIdsToUse, allAccountsByIds, categoriesById, transactionsByAccountId, dateInterval, frequencyData, utils_1.incomeFilters, filterCriteria, filterBySource);
})({
    // this line sets the key to use for the cache
    keySelector: (_, props) => props.accountIds ? `${props.accountIds.toString()}${props.startDate}${props.endDate}` : 'any',
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 6 }),
});
/**
 * Get spending data grouped by frequency
 */
exports.getSpendingForPeriods = (0, re_reselect_1.createCachedSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state) || categories_1.categoriesSelectors.getLoadPending(state) || (0, selectors_1.getLoadPending)(state), accounts_1.accountsSelectors.getReportableAccountsById, (_, props) => props.accountIds, selectors_1.getTransactionsByAccountId, categories_1.categoriesSelectors.getCategoriesById, (_, props) => props.dateInterval, (_, props) => props.frequency, (0, selectorsHelpers_1.createValueCache)((_, props) => props.filterCriteria), (_, props) => props.filterBySource, (isLoadPending, allAccountsByIds, accountIds, transactionsByAccountId, categoriesById, dateInterval, frequency, filterCriteria, filterBySource) => {
    // accounts, categories, and transactions must all be loaded before we attempt to calculate spending
    if (isLoadPending) {
        return null;
    }
    const stringifiedFilterCriteria = JSON.stringify(filterCriteria);
    const accountIdsToUse = accountIds || allAccountsByIds.keySeq();
    const cacheKey = (0, objectToKeyUtils_1.getOrCreateStringFromObject)('spending-periods', {
        allAccountsByIds,
        accountIdsToUse,
        transactionsByAccountId,
        categoriesById,
        dateInterval,
        frequency,
        stringifiedFilterCriteria,
        filterBySource,
    }, 6, memoizeWithKey_1.memoizeWithKeyRetrieveCache);
    // turn into trace statement after fixing issues with input properties changing all the time
    log.log('calculating spending for', allAccountsByIds, accountIds, dateInterval, frequency);
    // const parsedFilterCriteria = JSON.parse(filterCriteria);
    return (0, memoizeWithKey_1.memoizeWithKey)('spending-periods', () => {
        const criteria = filterCriteria;
        if (criteria && Array.isArray(criteria.items)) {
            const arrCategoryIds = [];
            categoriesById.forEach((objCategory) => {
                var _a;
                if (objCategory.parentId === ((_a = criteria.items) === null || _a === void 0 ? void 0 : _a[0])) {
                    arrCategoryIds.push(objCategory.id || '');
                }
            });
            if (arrCategoryIds.length > 0) {
                criteria.items.concat(arrCategoryIds);
            }
        }
        return (0, utils_1.calculateValuesForPeriods)(accountIdsToUse, allAccountsByIds, categoriesById, transactionsByAccountId, dateInterval, utils_1.monthlyFrequencyData, utils_1.spendingFilters, filterCriteria, filterBySource);
    }, cacheKey, 6);
})({
    // this line sets the key to use for the cache
    keySelector: (_state, { accountIds, dateInterval, frequency, filterCriteria }) => {
        const accountIdsKey = accountIds ? `${accountIds.toString()}` : 'all';
        return `${accountIdsKey}_${dateInterval ? dateInterval.toString() : 'default'}_${frequency || ''}_${filterCriteria ? JSON.stringify(filterCriteria) : ''}`;
    },
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }),
});
